import { useSelector, useDispatch } from 'react-redux';
import {useEffect, useState} from 'react';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { useAppState } from 'components/contexts/State';
import getPinnedTooltipCoordinate from 'utils/getPinnedTooltipCoordinate';

export const HISTORICALHIGHCOLLISIONVIEW_LAYER_ID = 'historicalHighCollisonLayer';

const layerConfig = {
  title: 'VRU Crash Heat Map',
};

function HistoricalHighCollisionLayer() {
  const dispatch = useDispatch();
  const { historicalHighCollisonLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, historicalHighCollisonLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });
  const viewState = useSelector((state) => state.carto.viewState);
  const pointLineWidth = viewState.zoom >= 7 ? 7 :4;
  let [domainArray, setDomainArray] = useState([1, 2, 4, 7, 10]);
  const {isVRUCrashesFilterActive, pinnedTooltip, setPinnedTooltip } = useAppState();

  useEffect(() => { 
    if (isVRUCrashesFilterActive) {
      setDomainArray([1, 2, 4, 7, 10]);
       
    } else {
       setDomainArray([1, 25, 75, 150, 200]);
    }
  }, [isVRUCrashesFilterActive]);


  if (historicalHighCollisonLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HISTORICALHIGHCOLLISIONVIEW_LAYER_ID,
      geoColumn: 'geom',
      stroked: false,
      filled: true,
      lineWidthMinPixels: pointLineWidth,
      lineWidthMaxPixels: 10,
      pickable: true,
      lineWidthScale: 1,
      visible: historicalHighCollisonLayer.visible,
      opacity: historicalHighCollisonLayer.opacity,

      getLineColor: colorBins({
        attr: 'Crash_Volume',
        domain: domainArray,
        colors: [
          [235, 74, 64, 0],
          [235, 74, 64, 64],
          [235, 74, 64, 128],
          [235, 74, 64, 192],
          [235, 74, 64, 255],
        ],
      }),
      coverage: 0.95,
      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HISTORICALHIGHCOLLISIONVIEW_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad?.(data);
           },

      onClick: (info) => {
        if (info?.object) {
          const html = htmlForFeature({ feature: info.object });
          if (pinnedTooltip?.html === html) {
            setPinnedTooltip(null);
          } else {
            setPinnedTooltip({
              html,
              postMileInfo: info.object.properties,
              coordinate: getPinnedTooltipCoordinate(info),
            });
          }
        }
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              //includeColumns: ['h3'],
            }),
          };
        }
      },
    });
  }
}

export default HistoricalHighCollisionLayer;
